import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { LoadingState } from '@shared/types/loading-state';
import { NextStep } from '@shared/models/next-step';
import { createNextStep } from '../actions/create-next-step.actions';
import * as fromNextSteps from '@features/next-steps/reducers/next-steps.reducer';
import { NextStepFilters } from '@shared/models/next-step-filters';
import { PaginationState } from '@shared/models/pagination-state';
import { Sorting } from '@shared/models/sorting';
import { loadNextSteps } from '../actions/load-next-steps.actions';
import { setNextStepsFilter } from '../actions/set-next-steps-filter.actions';

@Injectable({
  providedIn: 'root',
})
export class NextStepsService {
  constructor(private store: Store) {}

  createNextStep(nextStep: Partial<NextStep>) {
    this.store.dispatch(createNextStep({ nextStep: nextStep }));
  }

  loadNextSteps(filters: NextStepFilters, paginationState: PaginationState, sorting: Sorting) {
    this.store.dispatch(loadNextSteps({ filters, paginationState, sorting }));
  }

  getNextStepsLoading(): Observable<LoadingState> {
    return this.store.select(fromNextSteps.selectNextStepsLoadingState);
  }

  getNextStepsLoadingText(): Observable<string | undefined> {
    return this.store.select(fromNextSteps.selectNextStepsLoadingText);
  }

  getNextStepsPaginationState(): Observable<PaginationState | undefined> {
    return this.store.select(fromNextSteps.selectNextStepsPaginationState);
  }

  getNextStep(leadId?: number, groupId?: string, opportunityId?: number): Observable<NextStep | undefined> {
    return this.store.select(fromNextSteps.selectNextStep(leadId, groupId, opportunityId));
  }

  getSessionNextSteps(): Observable<NextStep[]> {
    return this.store.select(fromNextSteps.selectFilteredSessionUserNextSteps);
  }

  setNextStepsFilters(filters: NextStepFilters) {
    this.store.dispatch(setNextStepsFilter({ filters }));
  }

  getNextStepsFilters(): Observable<NextStepFilters> {
    return this.store.select(fromNextSteps.selectNextStepsFilter);
  }
}
